import { useMutation } from '@apollo/client';

import { AlertTitle, AlertType } from '@app/components/Alert';
import { APPLY_COUPON_MUTATION } from '@app/pages/Cart/CartCoupon/CartCoupon.queries';
import { FormattedMessage } from 'react-intl';
import useCartAlerts from './useCartAlerts';

import type {
  ApplyCouponMutation,
  ApplyCouponMutationVariables,
} from '@app/pages/Cart/CartCoupon/__generated__/ApplyCouponMutation';
import messages from '../pages/Cart/CartCoupon/CartCoupon.messages';

export function useAddCouponToCart() {
  const { clearCartAlerts, addCartAlerts } = useCartAlerts();

  const [applyCoupon, { loading, data, error }] = useMutation<
    ApplyCouponMutation,
    ApplyCouponMutationVariables
  >(APPLY_COUPON_MUTATION, {
    onError: (error) => {
      clearCartAlerts();
      addCartAlerts([
        {
          type: AlertType.Error,
          content: <AlertTitle>{error.message}</AlertTitle>,
          shouldShake: true,
        },
      ]);
    },
    onCompleted: () => {
      clearCartAlerts();
      addCartAlerts([
        {
          type: AlertType.Success,
          content: (
            <AlertTitle>
              <FormattedMessage {...messages.couponUpdated} />
            </AlertTitle>
          ),
        },
      ]);
    },
  });

  return { applyCoupon, loading, error, data };
}
